class window.BulletinFilter
  constructor: ->
    @bulletinForm = $("#bulletinForm")
    @elementsContainer = $(".js-documents-container")
    @paginationContainer = $(".js-bulletin-pagination-container")
    @paginationButton = $(".js-bulletin-pagination-button")
    @clearButton = $(".button-clear")
    @loadMessageBlock = null
    @loadBlock = $(".load-block")

    @initForm()
    @loadMoreDocuments(@paginationButton)
    @initClearButton()

  initForm: ->
    self = this

    @bulletinForm.submit (e) ->
      e.preventDefault()
      self.elementsContainer.html('')
      self.submitForm($(this))

  submitForm: (formElement) ->
    self = this

    action = formElement.attr("action")
    params = formElement.serialize()

    $.ajax
      url: action
      type: 'GET'
      dataType: 'html'
      data: params
      beforeSend: (xhr) ->
        self.loadBlock.toggle()
      success: (data) ->
        self.loadBlock.toggle()
        $("#filter-load-message").remove()
        self.elementsContainer.append(data)
        setTimeout (->
          self.paginationContainer = self.elementsContainer.find(".js-bulletin-pagination-container")
          self.paginationButton = self.elementsContainer.find(".js-bulletin-pagination-button")
          self.loadMoreDocuments(self.paginationButton)
        ), 500
        new window.NewsPopup()

      error: (error) ->
        console.log(error)

  loadMoreDocuments: (element) ->
    self = this

    element.click (e) ->
      $.ajax
        url: $(this).attr('data-href')
        type: 'GET'
        dataType: 'html'
        beforeSend: (xhr) ->
          self.paginationButton.prop('disabled', true)
          self.paginationButton.html("Пожалуйста подождите...")
        success: (data) ->
          self.paginationContainer.remove()
          self.elementsContainer.append(data)
          self.replacePagination()

  replacePagination: ->
    self = this

    newPaginationContainer = $(".js-bulletin-pagination-container")

    unless newPaginationContainer == undefined
      @paginationContainer = newPaginationContainer

      newPaginationButton = $(".js-bulletin-pagination-button")

      unless newPaginationButton == undefined
        @paginationButton = newPaginationButton
        @loadMoreDocuments(@paginationButton)

    new window.NewsPopup()

  initClearButton: ->
    self = this
    self.clearButton.hide()
    $('.bulletin__filter').find('input').each ->
      $(this).change ->
        # Проверяем что хоть в одном инпуте введен текст, и показываем кнопку очистить
        $('.bulletin__filter').find('input').each ->
          if $(this).val().length > 0
            self.clearButton.show()
            return false
          else
            self.clearButton.hide()

    # Слушаем изменения селектов
    $('.bulletin__filter').find('select').each ->
      $(this).on 'selectmenuchange', ->
        if $(this).val().length > 0
          self.clearButton.show()
          return false
        else
          self.clearButton.hide()



    # Кнопка очищения фильтров
    @clearButton.click ->
      if($(this).data("non-clear")=="Y") 
        $('.bulletin__filter').find('[name="query"]').val('')
        $('button[type="submit"]').click()
      else
        $('.bulletin__filter').find('input').each ->
          $(this).val('')

        $('.bulletin__filter').find('select').each ->
          $(this).val('')
          $(this).selectmenu("refresh");

        self.clearButton.hide()
        $.ajax
          url: "/"
          type: "GET"
          dataType: "html"
          beforeSend: (xhr) ->
            self.loadBlock.toggle()
            self.paginationContainer.remove()
            self.elementsContainer.html("")
          success: (data) ->
            self.loadBlock.toggle()
            content = $(data).find(".bulletin__documents .container").html()
            self.elementsContainer.append(content)
            self.replacePagination()


// WEBPACK FOOTER //
// ./assets/javascripts/app/bulletin_filter.coffee